export enum PiiClassifierColumnKeys {
    LastScan = 'lastScan',
  }